<div class="colored-header">
  <h2>
    {{ "translate.dashboard.ordersSummaryTitle" | translate }}
  </h2>
</div>
<div class="t-widget--noPadding order-summary-box">
  <div
    *ngFor="let s of data.ordersSummary"
    class="summary-row"
    [class.allow-hover]="s.cnt > 0"
    (click)="s.cnt > 0 ? filterOrdersBySummaryCode(s.summaryCode) : null"
  >
    <p class="lbl">{{ s.descr }}</p>
    <p class="value">{{ s.cnt | number }}</p>
  </div>
</div>
